import React, { memo } from "react";
import { androidUrl, appleUrl, AppStoreButton, Footer, FooterIconSmall, PlayStoreButton, useScreenWidth } from "../Landing";
import '../Landing.css'

const DeleteAccountRequest = () => {
    const { isDesktop, isTablet, isMobile, width } = useScreenWidth();

    return (
        <div style={{
            background: 'white',
            overflow: 'hidden',
            overflowY: 'scroll',
            height: '100vh',
            width: '100vw',
        }}>
            <link href="https://fonts.googleapis.com/css2?family=Playwrite+IT+Moderna:wght@100..400&family=Satisfy&display=swap" rel="stylesheet"/>
            <div style={{
                position: 'relative',
                display:'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: isMobile ? 'center' : 'space-between',
                alignItems: 'center',
                marginTop: 50,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 100,
                padding: 12,
                paddingTop: 8,
                paddingLeft: 40,
                paddingRight: 40,
                borderRadius: 80,
                backgroundColor: "white",
            }}>
                <FooterIconSmall/>
                <div
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    justifyContent: isMobile ? 'center' : 'space-between',
                    alignItems: 'center',
                    gap: 20,
                    marginTop: isMobile ? 20 : 0,
                }}>
                    <AppStoreButton size={isMobile ? 'small' : 'medium'} shadow={isMobile ? false : true}  color='black' onClick={() => window.open(appleUrl, '_blank')} />
                    <PlayStoreButton size={isMobile ? 'small' : 'medium'} shadow={isMobile ? false : true}  color='black' onClick={() => window.open(androidUrl, '_blank')} />
                </div>
            </div>
            
            <br/>
            
            {/* Delete Account Request Section */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: isMobile ? '20px' : '40px',
                margin: '0 auto',
                maxWidth: '800px',
                textAlign: 'center',
            }}>
                <h2 style={{
                    fontSize: isMobile ? '24px' : '32px',
                    marginBottom: '20px',
                    color: '#333',
                }}>Delete Account Request</h2>
                <p style={{
                    fontSize: isMobile ? '16px' : '18px',
                    marginBottom: '30px',
                    color: '#555',
                    lineHeight: 1.6,
                }}>
                    To delete your account and all associated data, please follow these steps:
                </p>
                <ol style={{
                    textAlign: 'left',
                    fontSize: isMobile ? '16px' : '18px',
                    color: '#555',
                    lineHeight: 1.6,
                    marginBottom: '30px',
                }}>
                    <li>Open the PeaColony app</li>
                    <li>Open one of your colonies</li>
                    <li>Go to Settings</li>
                    <li>Select "App Management"</li>
                    <li>Tap "Delete Account"</li>
                    <li>Confirm your choice</li>
                </ol>
                <p style={{
                    fontSize: isMobile ? '16px' : '18px',
                    marginBottom: '30px',
                    color: '#555',
                    lineHeight: 1.6,
                }}>
                    Alternatively, you can request account deletion by contacting our support team:
                </p>
                <a 
                    href="mailto:support@peacolony.com?subject=Account%20Deletion%20Request" 
                    style={{
                        display: 'inline-block',
                        backgroundColor: '#ff4444',
                        color: 'white',
                        padding: '12px 24px',
                        borderRadius: '30px',
                        textDecoration: 'none',
                        fontSize: isMobile ? '16px' : '18px',
                        fontWeight: 'bold',
                        boxShadow: '0 4px 6px rgba(255, 68, 68, 0.2)',
                        transition: 'all 0.3s ease',
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#ff2222'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#ff4444'}
                >
                    Request Account Deletion
                </a>
                <p style={{
                    fontSize: isMobile ? '14px' : '16px',
                    marginTop: '30px',
                    color: '#777',
                    lineHeight: 1.6,
                }}>
                    Please note: Account deletion is permanent and cannot be undone. All your data will be permanently removed from our servers within 30 days of your request.
                </p>
            </div>
            
            <Footer/>
            <div style={{position: 'relative', height: 150, width: '100vw' }}></div>
        </div>
    );
};

export default memo(DeleteAccountRequest);